import { aggregateRows } from "./simulationCalc";

function normalize(value) {
  return String(value || "").trim().toLowerCase();
}

export function filterSimulationRows(rows, filters) {
  const list = Array.isArray(rows) ? rows : [];
  const f = filters || {};
  const query = normalize(f.machineQuery);

  return list.filter((row) => {
    if (f.site && f.site !== "all" && row.site !== f.site) return false;
    if (f.line && f.line !== "all" && row.line !== f.line) return false;
    if (f.riskLevel && f.riskLevel !== "all" && row.riskLevel !== f.riskLevel) return false;
    if (f.status && f.status !== "all" && row.status !== f.status) return false;
    if (f.onlyBottlenecks && row.bottleneck === "Sem gargalo") return false;

    if (query) {
      const haystack = `${row.label} ${row.machineCode} ${row.machineName} ${row.bottleneck}`.toLowerCase();
      if (!haystack.includes(query)) return false;
    }

    return true;
  });
}

function groupKeyFor(row, groupBy) {
  if (groupBy === "period") return row.period;
  if (groupBy === "bottleneck") return row.bottleneck || "Sem gargalo";
  if (groupBy === "risk") return row.riskLevel || "Médio";
  return row.machineId;
}

function groupLabelFor(row, groupBy) {
  if (groupBy === "period") return row.period;
  if (groupBy === "bottleneck") return row.bottleneck || "Sem gargalo";
  if (groupBy === "risk") return `Risco ${row.riskLevel || "Médio"}`;
  return row.label;
}

export function buildResultRows(rows, { groupBy = "machine", tolerancePercent = 0 } = {}) {
  const list = Array.isArray(rows) ? rows : [];
  if (groupBy === "machine") {
    return list.map((row) => ({
      ...row,
      rowType: "machine",
      label: row.label,
    }));
  }

  const groups = new Map();
  for (const row of list) {
    const key = groupKeyFor(row, groupBy);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(row);
  }

  return Array.from(groups.entries()).map(([key, groupRows]) => {
    const first = groupRows[0] || {};
    const aggregate = aggregateRows(groupRows, tolerancePercent);
    return {
      id: `group_${groupBy}_${key}`,
      rowType: "group",
      label: groupLabelFor(first, groupBy),
      period: groupBy === "period" ? key : first.period,
      site: groupBy === "period" ? "-" : first.site || "-",
      line: groupBy === "period" ? "-" : first.line || "-",
      riskLevel: groupBy === "risk" ? key : first.riskLevel || "-",
      plan: aggregate.planTotal,
      simulated: aggregate.simulatedTotal,
      realized: aggregate.realizedTotal,
      attendancePct: aggregate.attendancePct,
      gap: aggregate.gap,
      status: aggregate.status,
      bottleneck: aggregate.mainBottleneck,
      rowCount: aggregate.rowCount,
    };
  });
}

export function buildUniqueOptions(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const sites = [...new Set(list.map((row) => row.site).filter(Boolean))].sort();
  const lines = [...new Set(list.map((row) => row.line).filter(Boolean))].sort();
  const risks = [...new Set(list.map((row) => row.riskLevel).filter(Boolean))].sort();
  return { sites, lines, risks };
}
